import { render, staticRenderFns } from "./OfferItem.vue?vue&type=template&id=1c7dd3c0&scoped=true&"
import script from "./OfferItem.vue?vue&type=script&lang=ts&"
export * from "./OfferItem.vue?vue&type=script&lang=ts&"
import style0 from "./OfferItem.vue?vue&type=style&index=0&id=1c7dd3c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7dd3c0",
  null
  
)

export default component.exports